import { useState } from 'react';

import { useDetail } from '@/domains/productDiscovery/ProductPage/hooks/useDetail';

import { getProductsToCompare } from '../services/productComparator.api';
import type { ProductToCompareI } from '../types';

export const useProductsToCompare = () => {
  const [productsToCompare, setProductsToCompare] = useState<
    ProductToCompareI[]
  >([]);
  const [fetching, setFetching] = useState(true);

  const { categoryId, modelId } = useDetail();

  const fetchProductsToCompare = async () => {
    setFetching(true);
    try {
      const fetchedProducts = await getProductsToCompare(modelId, categoryId);
      setProductsToCompare(fetchedProducts);
    } catch {
      setProductsToCompare([]);
    } finally {
      setFetching(false);
    }
  };

  return { fetching, productsToCompare, fetch: fetchProductsToCompare };
};
